import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import IUser from "../../types/user";
import {AuthService} from "../../services/AuthService";

export type AuthState = {
    authUser: IUser | null
}

const initialState: AuthState = {
    authUser: null
}

type TCredentialsPayload = {
    authUser: IUser | null
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentialsAction: (state, action: PayloadAction<TCredentialsPayload>) => {
            state.authUser = action.payload.authUser
        },
        setTokenAction: (state, action: PayloadAction<string>) => {
            if (action.payload) {
                AuthService.saveToken(action.payload)
            } else {
                AuthService.removeToken()
            }
        },
        removeCredentialsAction: (state) => {
            state.authUser = null
            AuthService.removeToken()
        },
    }
})

export const {setCredentialsAction, removeCredentialsAction, setTokenAction} = authSlice.actions
export default authSlice.reducer